import React, {
  useState,
  useEffect,
  useContext,
  useRef,
} from 'react';
import {
  Col,
  Container,
  Row,
  Form,
  Pagination,
 } from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { FaFilter } from 'react-icons/fa';
import PropTypes from 'prop-types';
import MealCard from './MealCard';
import { Mealcontext } from '../../../../context/MealContext';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';
import { DashboardContext } from '../../../../context/DashboardContext';
import Progressbar from '../../Loader';
import Loader from './Loader';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';
import { AuthContext } from '../../../../context/AuthContext';
 
const Search = ({ restaurantid }) => {
  const [mealOfferd, setMealOffered] = useState([]);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { refresh, setRefresh } = useContext(Mealcontext);
  const [searchQuery, setSearchQuery] = useState('');
  const [mealsdata, setMealsData] = useState([]);
  const [filteredMealsData, setFilteredMealsData] = useState([]);
  const { setTotalmeal } = useContext(DashboardContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const { countryId } = useContext(AuthContext);
  const isMounted = useRef(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const itemsPerPage = 7;
 
  const fetchMealsData = async () => {
    const formdata = new FormData();
    formdata.append('restaurant_id', restaurantid);
    formdata.append('country_id', countryId);
    try {
      setIsLoading(true);
      const response = await 
       fetch(`${apiGlobal}/restaurant/meal_data.php`, {
        method: 'POST',
        body: formdata,
       });
     
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
     
      const mealsResponse = await response.json();
 
      if (mealsResponse && Array.isArray(mealsResponse.data)) {
        console.log('Loaded successfully');
        if (isMounted.current) {
          setMealsData(mealsResponse.data);
          setFilteredMealsData(mealsResponse.data);
          setTotalmeal(mealsResponse.data.length);
          // console.log(mealsResponse.data);
        }
      } else {
        console.log('No data found or invalid format');
        if (isMounted.current) {
          setMealsData([]);
          setFilteredMealsData([]);
          setTotalmeal(0);
        }
      }
    } catch (err) {
      console.error('Error loading meals', err);
      setFetchError('Failed to load meals. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };


  // const CACHE_TTL = 60000; // TTL in milliseconds (1 minute)

  //   // Fetch Meals Data with Cache API and TTL
  //   const fetchMealsData = async (forceRefresh = false) => {
  //     setIsLoading(true);
   
  //     try {
  //       const cacheName = 'mealsCache'; // Define a cache name
  //       const cache = await caches.open(cacheName);
   
  //       const currentTime = new Date().getTime(); // Current timestamp in milliseconds

  //       if (!forceRefresh) {
  //       // Check if we have cached data for the API URL
  //       const cachedResponse = await 
  //       cache.match(`${apiGlobal}/restaurant/meal_restaurant_fetch.php?restaurant_id=${restaurantid}`);
  //       // const currentTime = new Date().getTime(); // Current timestamp in milliseconds
   
  //       if (cachedResponse) {
  //         const cachedData = await cachedResponse.json();
  //         const { cachedAt } = cachedData;
   
  //         // If cached data is older than the TTL (1 minute), invalidate the cache and fetch new data
  //         if (currentTime - cachedAt < CACHE_TTL) {
  //           console.log('Using cached data');
  //           setMealsData(cachedData.data);
  //           setFilteredMealsData(cachedData.data);
  //           setIsLoading(false);
  //           return; // Return early if cache is valid
  //         }
  //           console.log('Cache expired, fetching new data');
  //           // If cached data is expired, delete it from the cache
  //           await cache.delete(`${apiGlobal}/restaurant/meal_restaurant_fetch.php?restaurant_id=${restaurantid}`);
  //       }
  //     }
   
  //       // Fetch new data from API if cache is expired or not available
  //       const response = 
  // await fetch(`${apiGlobal}/restaurant/meal_restaurant_fetch.php?restaurant_id=${restaurantid}`);
  //       const mealsResponse = await response.json();
   
  //       if (mealsResponse && Array.isArray(mealsResponse.data)) {
  //         console.log('Loaded data from API');
  //         if (isMounted.current) {
  //           setMealsData(mealsResponse.data);
  //           setFilteredMealsData(mealsResponse.data);
   
  //           // Add TTL information to the data before caching
  //           const dataWithTTL = {
  //             data: mealsResponse.data,
  //             cachedAt: currentTime, // Store the time when the data was cached
  //           };
   
  //           // Cache the new response for future use
  //           await cache.put(
  // `${apiGlobal}/restaurant/meal_restaurant_fetch.php?restaurant_id=${restaurantid}`,
  //             new Response(JSON.stringify(dataWithTTL)),
  // );
  //         }
  //       } else {
  //         console.log('No data found');
  //         if (isMounted.current) {
  //           setMealsData([]);
  //           setFilteredMealsData([]);
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error loading meals', error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
   
  //   useEffect(() => {
  //     isMounted.current = true;
  //     fetchMealsData(); // Initial data fetch
   
  //     // Set interval to refresh data every 1 minute
  //     const intervalId = setInterval(fetchMealsData, 60000); // 60000ms = 1 minute
   
  //     // Clear the interval on component unmount
  //     return () => {
  //       isMounted.current = false;
  //       clearInterval(intervalId); // Clean up the interval
  //     };
  //   }, [refresh]); // Will re-fetch when refresh context changes
 
  useEffect(() => {
    isMounted.current = true;
    if (restaurantid) {
      fetchMealsData();
    }
    return () => {
      isMounted.current = false;
    };
  }, [refresh, restaurantid, apiGlobal, sideBarRefresh?.restaurantMealSearchRefresh]);
 
 
  
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1); // Reset to first page when searching
 
    if (query) {
      const filteredData = mealsdata.filter(meal => meal.name && meal.name.toLowerCase().includes(query.toLowerCase()));
      setFilteredMealsData(filteredData);
    } else {
      setFilteredMealsData(mealsdata);
    }
  };
 
  // Refresh handler
  const refreshHandler = () => {
    // fetchMealsData(true);
    setRefresh(prev => !prev);
    toast.success('Refreshing...');
  };
 
  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
 
  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMealsData.slice(indexOfFirstItem, indexOfLastItem);
 
  // Total pages
  const totalPages = Math.ceil(filteredMealsData.length / itemsPerPage);
 
  // Calculate which page numbers to show
  const getPageNumbers = () => {
    const totalPageNumbers = 3; // Show max 3 page numbers
    if (totalPages <= totalPageNumbers) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
   
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = startPage + totalPageNumbers - 1;
   
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(endPage - totalPageNumbers + 1, 1);
    }
   
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };
 
  // Render content based on loading and error states
  const renderContent = () => {
    if (isLoading) {
      return <Loader />;
    }
   
    if (fetchError) {
      return <p>{fetchError}</p>;
    }
   
    if (filteredMealsData.length === 0) {
      return <p>No meals found</p>;
    }
   
    return currentItems.map(meal => (
      <div key={meal.id || `meal-${Math.random()}`}>
        <MealCard
          id={meal.id}
          mealname={meal.name}
          restaurantname={meal.restaurant_name}
          description={meal.description}
          type={meal.meal_type}
          capacity={meal.capacity}
          price={meal.price}
          finalprice={meal.final_price}
          format={meal.meal_format}
          image={meal.photo}
          isVeg={meal.veg_non_veg}
          mealOffereds={meal.meal_offered}
          cuisine={meal.cuisines}
          // refreshHandler={refreshHandler}
        />
      </div>
    ));
  };
 
  return (
    <div>
      <Container>
        <Row>
          <Col md={12} />
        </Row>
 
        <Row>
          <div className="col-md-4 mb-4 d-flex align-items-center">
            <Form.Control
              type="text"
              placeholder="Search by Meal Name..."
              value={searchQuery}
              onChange={handleSearch}
              className="flex-grow-1"
            />
            <ButtonGroup icons dir="ltr" className="mt-2">
              <Button
                variant="outline-secondary"
                className="ms-3"
                title="Refresh"
                size="sm"
                onClick={refreshHandler}
              >
                <span className="lnr lnr-sync" />
              </Button>
            </ButtonGroup>
 
            {/* <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
              <Button
                variant="outline-info"
                title="Filter"
              >
                <FaFilter />
              </Button>
            </ButtonGroup> */}
          </div>
        </Row>
 
        <Row>
          <div>
            {renderContent()}
          </div>
        </Row>
       
        {/* Pagination Controls - Right-aligned with First/Last Page */}
        {!isLoading && filteredMealsData.length > 0 && (
          <Row className="mt-3 mb-3">
            <Col className="d-flex justify-content-end">
              <Pagination size="sm">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />
               
                {getPageNumbers().map(number => (
                  <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => handlePageChange(number)}
                  >
                    {number}
                  </Pagination.Item>
                ))}
               
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                />
                <Pagination.Last
                  onClick={() => handlePageChange(totalPages)}
                  disabled={currentPage === totalPages || totalPages === 0}
                />
              </Pagination>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};
 
Search.propTypes = {
  restaurantid: PropTypes.string.isRequired,
};
 
export default Search;

// import React, { 
//   useState, 
//   useEffect, 
//   useContext, 
//   useRef, 
// } from 'react';
// import { 
//   Col, 
//   Container, 
//   Row, 
//   Form,
//   Pagination,
//  } from 'react-bootstrap';
// import { Button, ButtonGroup } from '@/shared/components/Button';
// import toast from 'react-hot-toast';
// import { FaFilter } from 'react-icons/fa';
// import PropTypes from 'prop-types';
// import MealCard from './MealCard';
// import { Mealcontext } from '../../../../context/MealContext';
// import { GlobalVarContext } from '../../../../context/GlobalVarContext';
// import { DashboardContext } from '../../../../context/DashboardContext';
// import Loader from '../../Loader';


// const Search = ({ restaurantid }) => {
//   const [mealOfferd, setMealOffered] = useState([]);
//   const { apiGlobal } = useContext(GlobalVarContext);
//   const { refresh, setRefresh } = useContext(Mealcontext);
//   const [searchQuery, setSearchQuery] = useState(''); 
//   const [mealsdata, setMealsData] = useState([]);
//   const [filteredMealsData, setFilteredMealsData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { setTotalmeal } = useContext(DashboardContext);
//   const isMounted = useRef(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 7;

//   const fetchMealsData = async () => {
//     try {
//       const response = 
// await fetch(`${apiGlobal}/restaurant/meal_restaurant_fetch.php?restaurant_id=${restaurantid}`);
//       const mealsResponse = await response.json();

//       if (mealsResponse && Array.isArray(mealsResponse.data)) {
//         console.log('Loaded successfully');
//         if (isMounted.current) {
//           setMealsData(mealsResponse.data);
//           setFilteredMealsData(mealsResponse.data);
//           setTotalmeal(mealsResponse.data.length);
          
//           console.log(mealsResponse.data);
//         }
//       } else {
//         console.log('No data found');
//         if (isMounted.current) {
//           setMealsData([]);
//           setFilteredMealsData([]);
//         }
//       }
//     } catch (error) {
//       console.error('Error loading meals', error);
//     }
//   };

//   useEffect(() => {
//     isMounted.current = true;
//     fetchMealsData();
//     return () => {
//       isMounted.current = false;
//     };
//   }, [refresh]); 


//   const handleSearch = (e) => {
//     const query = e.target.value;
//     setSearchQuery(query);

//     if (query) {
//       const filteredData = mealsdata.filter(meal => meal.name.toLowerCase().includes(query.toLowerCase()));
//       setFilteredMealsData(filteredData); 
//     } else {
//       setFilteredMealsData(mealsdata); 
//     }
//   };

//   // Refresh handler
//   const refreshHandler = () => {
//       // fetchMealsData(); 
//       setRefresh(prev => !prev);
//       toast.success('Refreshing...');
//   };

//   // Handle page change
// const handlePageChange = (pageNumber) => {
//   setCurrentPage(pageNumber);
// };

// // Pagination Logic - Slice data for the current page
// const indexOfLastItem = currentPage * itemsPerPage;
// const indexOfFirstItem = indexOfLastItem - itemsPerPage;
// const currentItems = filteredMealsData.slice(indexOfFirstItem, indexOfLastItem);

// // Total pages
// const totalPages = Math.ceil(filteredMealsData.length / itemsPerPage);


// if (loading) {
//   return <div>Loading...</div>;
// }


//   return (

//     <div>
//       <Container>
//         <Row>
//           <Col md={12} />
//         </Row>

//         <Row>
//           <div className="col-md-6 mb-4 d-flex align-items-center">
//             <Form.Control
//               type="text"
//               placeholder="Search by Meal Name..."
//               value={searchQuery}
//               onChange={handleSearch}
//               className="flex-grow-1"
//             />
//             <ButtonGroup icons dir="ltr" className="mt-2">
//               <Button
//                 variant="outline-secondary"
//                 className="ms-3"
//                 title="Refresh"
//                 size="sm"
//                 onClick={refreshHandler}
//               >
//                 <span className="lnr lnr-sync" />
//               </Button>
//             </ButtonGroup>

//             <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
//               <Button 
//                 variant="outline-info"
//                 title="Filter" 
//               >
//                 <FaFilter />
//               </Button>
//             </ButtonGroup>
//           </div>
//         </Row>

//         <Row>
//           <div>
//             {filteredMealsData.length === 0 ? (
//               <p>No meals found</p>
//             ) : (
//               currentItems.map(meal => (
//                 <div key={meal.id}>
//                   <MealCard
//                     id={meal.id}
//                     mealname={meal.name}
//                     restaurantname={meal.restaurant_name}
//                     description={meal.description}
//                     type={meal.meal_type}
//                     capacity={meal.capacity}
//                     price={meal.price}
//                     finalprice={meal.final_price}
//                     format={meal.meal_format}
//                     image={meal.photo}
//                     isVeg={meal.veg_non_veg}
//                     mealOffereds={meal.meal_offered}
//                     cuisine={meal.cuisines}
//                   />
//                 </div>
//               ))
//             )}
//           </div>
//         </Row>
//       </Container>
//       {/* Pagination Controls */}
//       <div style={{
// //  position: 'fixed', 
//         bottom: '20px', 
//         right: '20px', 
//         zIndex: 999, 
//         display: 'flex', 
//         justifyContent: 'flex-end', 
//         alignItems: 'center', 
// }}
//       >
//         <Pagination>
//           <Pagination.Prev
//             onClick={() => handlePageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           />
//           {Array.from({ length: totalPages }, (_, index) => (
//             <Pagination.Item
//               key={index + 1}
//               active={index + 1 === currentPage}
//               onClick={() => handlePageChange(index + 1)}
//             >
//               {index + 1}
//             </Pagination.Item>
//           ))}
//           <Pagination.Next
//             onClick={() => handlePageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           />
//         </Pagination>
//       </div>
//     </div>
//   );
// };

// Search.propTypes = {
//   restaurantid: PropTypes.string.isRequired,
// };

// export default Search;
